<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> |
    <router-link to="/vue">Vue</router-link>
    <router-link to="/things">Things</router-link> |
    <router-link to="/cost-of-living">Cost of Living</router-link>
  </div>  
  <SolarBackground/>
  <div id="component">
    <router-view/>
  </div>
</template>

<style scoped>
  @import url(./assets/styles/main.css);
</style>

<script>
import SolarBackground from '@/components/SolarBackground.vue'

export default {
        name: 'App',
        components: {
            SolarBackground
        }
    }
</script>

